import React, { Suspense } from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { ROUTES } from "./routes";
import PageNotFound from "./components/pages/PageNotFound/PageNotFound";
import LoaderSuspense from "./components/common/Loader/Loader";
import { useSelector } from "react-redux";
import NoGuard from "./Guard/UnAuthGuard";
import AuthGuard from "./Guard/AuthGuard";
import OpenedTransactions from "./components/pages/MainScreens/Transactions/OpenedTransactions/OpenedTransactions";
import CompletedTransactions from "./components/pages/MainScreens/Transactions/CompletedTransactions/CompletedTransactions";
import OpenedOrders from "./components/pages/MainScreens/Orders/OpenedOrders/OpenedOrders";
import CompletedOrders from "./components/pages/MainScreens/Orders/CompletedOrders/CompletedOrders";

import Fees from "./components/pages/MainScreens/Settings/Fees/Fees";
import TermsConditions from "./components/pages/MainScreens/Settings/TermsConditions/TermsConditions";
import PrivacyPolicy from "./components/pages/MainScreens/Settings/PrivacyPolicy/PrivacyPolicy";
import P2POrders from "./components/pages/MainScreens/P2POrders/P2POrders";
import Orders from "./components/pages/MainScreens/Orders/Orders";
import PaymentStatus from "./components/pages/MainScreens/MarketPlace/PaymentStatusPage.js/PaymentStatus";
import Redeem from "./components/pages/MainScreens/Dashboard/WalletValueCard/Redeem/Redeem";
import Sell from "./components/pages/MainScreens/Dashboard/WalletValueCard/P2pTab/Sell/Sell";
import Convert from "./components/pages/MainScreens/Dashboard/WalletValueCard/Convert/Convert";
import Buy from "./components/pages/MainScreens/Dashboard/WalletValueCard/P2pTab/Buy/Buy";
import Dashboard from "./components/pages/MainScreens/Dashboard/Dashboard";
import Investments from "./components/pages/MainScreens/Investments/Investments";
import MarketPlace from "./components/pages/MainScreens/MarketPlace/MarketPlace";
import Transactions from "./components/pages/MainScreens/Transactions/Transactions";
import Settings from "./components/pages/MainScreens/Settings/Settings";
import Help from "./components/pages/MainScreens/Help/Help";
import MyProfile from "./components/pages/MainScreens/Settings/MyProfile/MyProfile";
import Feature1 from "./components/pages/MainScreens/Help/Feature1/Feature1";
import Feature2 from "./components/pages/MainScreens/Help/Feature2/Feature2";
import Feature3 from "./components/pages/MainScreens/Help/Feature3/Feature3";
import Feature4 from "./components/pages/MainScreens/Help/Feature4/Feature4";
import Login from "./components/pages/OnboardScreens/Login/Login";
import Register from "./components/pages/OnboardScreens/Register/Register";
import ResetPassword from "./components/pages/OnboardScreens/ResetPassword/ResetPassword";
import EmailVerification from "./components/pages/OnboardScreens/EmailVerification/EmailVerification";
import SetNewPassword from "./components/pages/OnboardScreens/SetNewPassword/SetNewPassword";
import ForgotPasswordEmail from "./components/pages/OnboardScreens/ForgotPasswordEmail/ForgotPasswordEmail";
import SecurityVerification from "./components/pages/OnboardScreens/SecurityVerification/SecurityVerification";
import WalletPortfolio from "./components/pages/MainScreens/WalletPortfolio/WalletPortfolio";
import UserReportDetails from "./components/pages/MainScreens/Report/Report";
import UserReportDetailTransactions from "./components/pages/MainScreens/ReportDetails/ReportDetails";
import BuyOrders from "./components/pages/MainScreens/P2POrders/BuyOrders/BuyOrders";
import SellOrders from "./components/pages/MainScreens/P2POrders/SellOrders/SellOrders";
import MyOrders from "./components/pages/MainScreens/P2POrders/MyTransactions/MyOrders";
import CryptoWallet from "./components/pages/MainScreens/CryptoWallet/CryptoWallet";
import REPORT from "./components/pages/MainScreens/Report/Report";
import DespositTransaction from "./components/pages/MainScreens/CryptoWallet/DespositTransaction/DespositTransaction";
import Deposit from "./components/pages/MainScreens/CryptoWallet/DespositTransaction/Deposit/Deposit";
import Widthrow from "./components/pages/MainScreens/CryptoWallet/DespositTransaction/Widthrow/Widthrow";
import P2pTab from "./components/pages/MainScreens/Dashboard/WalletValueCard/P2pTab/P2pTab";
import Unsubscribe from "./components/pages/OnboardScreens/Unsubscribe/Unsubscribe";
import BuyEquity from "./components/pages/MainScreens/BuyEquity/BuyEquity";
import PortfolioBalance from "./components/pages/MainScreens/Dashboard/PortfolioBalance/PortfolioBalance";
import VerifyKyc from "./components/pages/MainScreens/Dashboard/PortfolioBalance/VerifyKyc/VerifyKyc";
import STBLMoney from "./components/pages/MainScreens/STBLMoney/STBLMoney";
import CardSettings from "./components/pages/MainScreens/STBLMoney/CardSettings/CardSettings";
import NocardGuard from "./Guard/NocardGuard";
import FreezeCard from "./components/pages/MainScreens/STBLMoney/FreezeCard/FreezeCard";
import CardStatements from "./components/pages/MainScreens/STBLMoney/CardStatement/CardStatement";
import CardStatement from "./components/pages/MainScreens/STBLMoney/CardStatement/CardStatement";
import AmountDetails from "./components/pages/MainScreens/STBLMoney/AmountDetails/AmountDetails";
import ViewCardPin from "./components/pages/MainScreens/STBLMoney/ViewCardPin/ViewCardPin";
import ReportIssues from "./components/pages/MainScreens/STBLMoney/ReportIssues/ReportIssues";
import ApplyCard from "./components/pages/MainScreens/STBLMoney/ApplyCard/ApplyCard";
import ApplyCardForm from "./components/pages/MainScreens/STBLMoney/ApplyCard/ApplyCardForm/ApplyCardForm";
import ManageCard from "./components/pages/MainScreens/STBLMoney/ManageCard/ManageCard";
import SetUpdateCardPin from "./components/pages/MainScreens/STBLMoney/SetUpdateCardPin/SetUpdateCardPin";
import RecentTransactions from "./components/pages/MainScreens/STBLMoney/RecentTransactions/RecentTransactions";
import ViewStatement from "./components/pages/MainScreens/STBLMoney/ViewStatement/ViewStatement";
import PrivacyNotice from "./components/pages/Legal/PrivacyNotice";
import IssuerInternationalPrivacyPolicy from "./components/pages/Legal/IssuerInternationalPrivacyPolicy";
import ESignConsent from "./components/pages/Legal/ESignConsent";
import CardTermsUS from "./components/pages/Legal/CardTermsUS";
import CardTermsInternational from "./components/pages/Legal/CardTermsInternational";
import Prohibitions from "./components/pages/Legal/Prohibitions";
import CardTerms from "./components/pages/Legal/CardTerms";
import CardDisclosuresAgreement from "./components/pages/Legal/CardDisclosuresAgreement";
import AccountOpeningPrivacyNotice from "./components/pages/Legal/AccountOpeningPrivacyNotice";
import Maintenance from "./components/pages/Maintenance/Maintenance";
const ErrorPage = React.lazy(() =>
  import("./components/pages/ErrorPage/ErrorPage")
);

const router = createBrowserRouter([
  {
    path: "/",
    errorElement: <ErrorPage />,
    element: <NoGuard />,
    children: [
      {
        index: true,
        element: <Login />,
      },
      {
        path: ROUTES.REGISTER,
        element: <Register />,
      },
      {
        path: ROUTES.RESET_PASSWORD,
        element: <ResetPassword />,
      },
      {
        path: ROUTES.EMAIL_VERIFICATION,
        element: <EmailVerification />,
      },
      {
        path: ROUTES.SET_NEW_PASSWORD,
        element: <SetNewPassword />,
      },
      {
        path: ROUTES.FORGOT_EMAIL_VERIFICATION,
        element: <ForgotPasswordEmail />,
      },
      {
        path: ROUTES.SECURITY_VERIFICATION,
        element: <SecurityVerification />,
      },
      {
        path: ROUTES.UNSUBSCRIBE,
        element: <Unsubscribe />,
      },
    ],
  },
  {
    path: ROUTES.AUTH,
    element: <AuthGuard />,
    children: [
      {
        path: ROUTES.DASHBOARD,
        element: <Dashboard />,
        children: [
          {
            path: ROUTES.P2P,
            element: <P2pTab />,
            children: [
              {
                path: ROUTES.BUY,
                element: <Buy />,
              },
              {
                path: ROUTES.SELL,
                element: <Sell />,
              },
            ],
          },
          {
            path: ROUTES.REDEEM,
            element: <Redeem />,
          },
          {
            path: ROUTES.CONVERT,
            element: <Convert />,
          },
        ],
      },
      {
        path: ROUTES.INVESTMENTS,
        element: <Investments />,
      },
      {
        path: ROUTES.BUY_EQUITY,
        element: <BuyEquity />,
      },
      {
        path: ROUTES.MARKETPLACE,
        element: <MarketPlace />,
      },
      {
        path: ROUTES.PAYMENT_STATUS,
        element: <PaymentStatus />,
      },
      {
        path: ROUTES.TRANSACTIONS,
        element: <Transactions />,
        children: [
          {
            path: ROUTES.TRANSACTIONS_OPENED,
            element: <OpenedTransactions />,
          },
          {
            path: ROUTES.TRANSACTIONS_COMPLETED,
            element: <CompletedTransactions />,
          },
        ],
      },
      {
        path: ROUTES.APPLY_CARD,
        element: <NocardGuard />,
        children: [
          {
            index: true,
            // path: ROUTES.CARD_SETTINGS,
            element: <ApplyCard />,
          },
          {
            path: ROUTES.APPLY_CARD_FORM,
            element: <ApplyCardForm />,
          },
        ]
      },
      {
        path: ROUTES.STBL_MONEY,
        element: <NocardGuard />,
        children: [
          {
            index: true,
            // path: ROUTES.CARD_SETTINGS,
            element: <STBLMoney />,
          },
          {
            path: ROUTES.RECENT_TRANSACTIONS,
            element: <RecentTransactions />,
          },
          {
            path: ROUTES.VIEW_STATEMENT,
            element: <ViewStatement />,
          },
          {
            path: ROUTES.CARD_SETTINGS,
            element: <CardSettings />,
          },
          {
            path: ROUTES.FREEZE_CARD,
            element: <FreezeCard />,
          },
          {
            path: ROUTES.CARD_STATEMENT,
            element: <CardStatement />,
          },
          {
            path: ROUTES.MANAGE_CARD,
            element: <ManageCard />,
          },
          {
            path: ROUTES.AMOUNT_DETAILS,
            element: <AmountDetails />,
          },
          {
            path: ROUTES.REPORT_ISSUES,
            element: <ReportIssues />,
          },
          {
            path: ROUTES.VIEW_CARD_PIN,
            element: <ViewCardPin />,
          },
          {
            path: ROUTES.SET_UPDATE_CARD_PIN,
            element: <SetUpdateCardPin />,
          },
        ],
      },
      {
        path: ROUTES.ORDERS,
        element: <Orders />,
        children: [
          {
            path: ROUTES.ORDERS_OPENED,
            element: <OpenedOrders />,
          },
          {
            path: ROUTES.ORDERS_COMPLETED,
            element: <CompletedOrders />,
          },
        ],
      },
      {
        path: ROUTES.PAYMENT_STATUS,
        element: <PaymentStatus />,
      },
      {
        path: ROUTES.SETTINGS,
        element: <Settings />,
        children: [
          {
            path: ROUTES.MY_PROFILE,
            element: <MyProfile />,
          },
          {
            path: ROUTES.FEES,
            element: <Fees />,
          },
          {
            path: ROUTES.TERMS_CONDITIONS,
            element: <TermsConditions />,
          },
          {
            path: ROUTES.PRIVACY_POLICY,
            element: <PrivacyPolicy />,
          },
        ],
      },
      {
        path: ROUTES.HELP,
        element: <Help />,
        children: [
          {
            path: ROUTES.HELP_FEATURE_1,
            element: <Feature1 />,
          },
          {
            path: ROUTES.HELP_FEATURE_2,
            element: <Feature2 />,
          },
          {
            path: ROUTES.HELP_FEATURE_3,
            element: <Feature3 />,
          },
          {
            path: ROUTES.HELP_FEATURE_4,
            element: <Feature4 />,
          },
        ],
      },
      {
        path: ROUTES.P2P_ORDERS,
        element: <P2POrders />,
        children: [
          {
            path: ROUTES.P2P_ORDERS_LIST,
            element: <BuyOrders />,
          },
          {
            path: ROUTES.MY_ORDERS,
            element: <MyOrders />,
          },
        ],
      },
      {
        path: ROUTES.WALLETPORTFOLIO,
        element: <WalletPortfolio />,
      },
      {
        path: ROUTES.REPORT,
        element: <UserReportDetails />,
      },
      {
        path: ROUTES.REPORTDETAILS,
        element: <UserReportDetailTransactions />,
      },
      // {
      //   path: ROUTES.CRYPTOWALLET,
      //   element: <CryptoWallet />,
      // },
      {
        path: ROUTES.DESPOSIT_TRANSACTIONS,
        element: <DespositTransaction />,
        children: [
          {
            index: true,
            path: ROUTES.DESPOSIT,
            element: <Deposit />,
          },
          {
            path: ROUTES.WIDTHROW,
            element: <Widthrow />,
          },
          {
            path: ROUTES.ALL_COINS,
            // element: <DespositTransaction />,
          },
        ],
      },
      {
        path: ROUTES.VERIFY_KYC,
        element: <VerifyKyc />,
      },
    ],
  },
  {
    path: ROUTES.CARD_TERMS,
    element: <CardTerms />,
  },
  {
    path: ROUTES.CARD_DISCLOSURES_AGREEMENT,
    element: <CardDisclosuresAgreement />,
  },
  {
    path: ROUTES.ACCOUNT_OPENING_PRIVACY_NOTICE,
    element: <AccountOpeningPrivacyNotice />,
  },
  {
    path: ROUTES.PRIVACY_NOTICE,
    element: <PrivacyNotice />,
  },
  {
    path: ROUTES.ISSUER_PRIVACY_POLICY_INTERNATIONAL,
    element: <IssuerInternationalPrivacyPolicy />,
  },
  {
    path: ROUTES.ESIGN_CONSENT,
    element: <ESignConsent />,
  },
  {
    path: ROUTES.CARD_TERMS_US,
    element: <CardTermsUS />,
  },
  {
    path: ROUTES.CARD_TERMS_INTERNATIONAL,
    element: <CardTermsInternational />,
  },
  {
    path: ROUTES.PROHIBITIONS,
    element: <Prohibitions />,
  },
  {
    path: ROUTES.MAINTENANCE,
    element: <Maintenance />,
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
]);

const IS_MAINTENANCE = true;

const maintenanceRouter = createBrowserRouter([
  {
    path: "*",
    element: <Maintenance />,
  },
]);

const Application = () => {
  const loading = useSelector((state) => state?.loading?.loading);

  React.useEffect(() => {
    const handleGlobalSubmit = (e) => {
      // Allow Veriff form to submit (it's protected by a hidden iframe in VerifyKyc.js)
      if (e.target.name === "veriff-form" || e.target.classList.contains("veriff-container")) {
        return;
      }
      e.preventDefault();
    };

    window.addEventListener("submit", handleGlobalSubmit, true);
    return () => window.removeEventListener("submit", handleGlobalSubmit, true);
  }, []);

  return (
    <Suspense fallback={<LoaderSuspense />}>
      <>
        {loading ? <LoaderSuspense /> : null}
        {/* <RouterProvider router={IS_MAINTENANCE ? maintenanceRouter : router} /> */}
            <RouterProvider router={router} />
      </>
    </Suspense>
  );
};

export default Application;
